<template>
    <vl-input-group v-if="downloadUrls" class="kl-sidebar__section__actions">
        <vl-select name="download-filetype" id="download-filetype" v-model="downloadFiletype"
                   @input="downloadFiletypeChanged" mod-no-placeholder mod-block>
            <optgroup label="Lambert 72">
                <option :value="parseValue(downloadUrl)" v-for="downloadUrl in lambert72DownloadUrls" :key="parseValue(downloadUrl)">
                    {{ downloadUrl.fileFormat }} - Lambert 72
                </option>
            </optgroup>
            <optgroup label="Lambert 2008">
                <option :value="parseValue(downloadUrl)" v-for="downloadUrl in lambert2008DownloadUrls" :key="parseValue(downloadUrl)">
                    {{ downloadUrl.fileFormat }} - Lambert 2008
                </option>
            </optgroup>
        </vl-select>
        <a :href="downloadFileUri" v-if="downloadFileUri && downloadFiletype" class="vl-button vl-button--narrow" download>Download</a>
    </vl-input-group>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref} from 'vue';
import userLocalStorage from '@/storage/user-local-storage';
import {CoordinateSystem, DownloadUrl} from "@/api/klip-api.proxy";

export default defineComponent({
    name: 'KlDrawZoneSidebarDownload',
    props: {
        downloadUrls: {
            type: Array as () => Array<DownloadUrl>,
            required: false,
            default: undefined,
        },
    },
    setup(props, { emit }) {

        const _downloadPreferenceLocalStorageKey: string = 'geometry_download_preference';

        const downloadFiletype = ref<string>(`GeoJson_${CoordinateSystem[CoordinateSystem.Lambert72]}`);

        const downloadFileUri = computed<string>(() => {
            if(props.downloadUrls && downloadFiletype.value) {
                const fileType = downloadFiletype.value.split('_')[0];
                const coordinateSystem = downloadFiletype.value.split('_')[1];
                return props.downloadUrls.find((downloadUrl: DownloadUrl) => downloadUrl.fileFormat === fileType && downloadUrl.coordinateSystem === CoordinateSystem[coordinateSystem as keyof typeof CoordinateSystem])?.url;
            }
            return null;
        });

        const parseValue = (DownloadUrl: DownloadUrl) => {
            return `${DownloadUrl.fileFormat}_${CoordinateSystem[DownloadUrl.coordinateSystem]}`;
        };

        const downloadFiletypeChanged = () => {
            userLocalStorage.setItem(_downloadPreferenceLocalStorageKey, downloadFiletype.value);
        }

        const lambert72DownloadUrls = computed<Array<DownloadUrl>>(() => {
            return props.downloadUrls.filter((downloadUrl: DownloadUrl) => downloadUrl.coordinateSystem === CoordinateSystem.Lambert72);
        });

        const lambert2008DownloadUrls = computed<Array<DownloadUrl>>(() => {
            return props.downloadUrls.filter((downloadUrl: DownloadUrl) => downloadUrl.coordinateSystem === CoordinateSystem.Lambert2008);
        });

        onMounted(() => {
            let preferenceFromLocalStorage = userLocalStorage.getItem(_downloadPreferenceLocalStorageKey) || `GeoJson_${CoordinateSystem[CoordinateSystem.Lambert72]}`;
            if(!preferenceFromLocalStorage.includes('_')){
                //this is possible with values before the Lambert2008 migration from the localstorage
                preferenceFromLocalStorage = `${preferenceFromLocalStorage}_${CoordinateSystem[CoordinateSystem.Lambert72]}`;
            }
            downloadFiletype.value = preferenceFromLocalStorage;
        });

        return {
            parseValue,
            downloadFiletype,
            downloadFileUri,
            downloadFiletypeChanged,
            lambert72DownloadUrls,
            lambert2008DownloadUrls,
        }
    }
})

</script>

